import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const SLEEP_ROUTINES: Partial<Routine>[] = [
  {
    id: "bedtime-winddown",
    title: "Bedtime Wind-Down",
    symbol: "🛌",
    description: "A calming routine to prepare your body for sleep",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[0].value,
    steps: [
      {
        id: "sleep-winddown-1",
        title: "Digital sunset",
        description: "Turn off screens 1 hour before bedtime to reduce blue light exposure",
      },
      {
        id: "sleep-winddown-2",
        title: "Relaxation activity",
        description: "Read a book, practice gentle stretching, or meditate for 15-20 minutes",
      },
      {
        id: "sleep-winddown-3",
        title: "Prepare your sleep environment",
        description: "Dim lights, ensure comfortable temperature, and reduce noise",
      },
    ],
  },
  {
    id: "morning-sleep-optimizer",
    title: "Morning Sleep Optimizer",
    symbol: "🛌",
    description: "Start your day with habits that improve tonight's sleep",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[1].value,
    steps: [
      {
        id: "sleep-morning-1",
        title: "Consistent wake-up",
        description: "Get up at the same time each day, even on weekends",
      },
      {
        id: "sleep-morning-2",
        title: "Morning sunlight",
        description: "Expose yourself to natural light within 30 minutes of waking",
      },
      {
        id: "sleep-morning-3",
        title: "Caffeine cutoff",
        description: "Enjoy morning caffeine, but avoid it after noon",
      },
    ],
  },
  {
    id: "sleep-reset-weekend",
    title: "Sleep Reset Weekend",
    symbol: "🛌",
    description: "Reset your sleep patterns during the weekend",
    dailyRoutine: false,
    selectedDays: [{ day: "saturday", datetime: "20:00:00.000Z" }],
    color: RoutineColors[2].value,
    steps: [
      {
        id: "sleep-reset-1",
        title: "Early evening meal",
        description: "Eat dinner at least 3 hours before bedtime",
      },
      {
        id: "sleep-reset-2",
        title: "Technology-free evening",
        description: "Avoid screens and engage in calming activities instead",
      },
      {
        id: "sleep-reset-3",
        title: "Prepare for the week",
        description: "Plan your upcoming week to reduce anxiety about pending tasks",
      },
    ],
  },
];
